module.exports = __webpack_public_path__ + "img/dldyq-yndt.ae94ac62.jpg";